import { Splide } from '@splidejs/splide';

import FadeTransition from './FadeTransition';

export default function Slider(el, customOptions) {
  // Prevent focusing button on click, this is important for styling
  el.querySelectorAll('.splide__arrow').forEach((arrow) =>
    arrow.addEventListener('mousedown', (ev) => ev.preventDefault())
  );

  const options = {
    autoWidth: true,
    keyboard: 'focused',
    pagination: false,
    type: 'slide',
  };

  Object.assign(options, customOptions);

  const splide = new Splide(el, options);

  splide.on('visible', (slide) => {
    if (
      !splide?.Components?.Arrows?.arrows?.prev ||
      !splide?.Components?.Arrows?.arrows?.next
    )
      return;

    if (slide.index === 0) {
      splide.Components.Arrows.arrows.prev.disabled = true;
    }

    if (slide.index === splide.length - 1) {
      splide.Components.Arrows.arrows.next.disabled = true;
    }
  });

  splide.on('hidden', (slide) => {
    if (
      !splide?.Components?.Arrows?.arrows?.prev ||
      !splide?.Components?.Arrows?.arrows?.next
    )
      return;

    if (slide.index === 0) {
      splide.Components.Arrows.arrows.prev.disabled = false;
    }

    if (slide.index === splide.length - 1) {
      splide.Components.Arrows.arrows.next.disabled = false;
    }
  });

  splide.on('drag', () => {
    if (!splide?.Components?.Autoplay) return;

    splide.Components.Autoplay.pause();
  });

  return splide.mount({}, FadeTransition);
}
